<template>
  <v-flex d-flex>
    <v-container fluid>
      <v-fab-transition>
        <v-btn fixed bottom right dark fab color="pink" @click="refresh" :loading="loading">
          <v-icon>cached</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-card>
        <v-card-title primary-title>
          <h2>Virtual Balance Config</h2>
          <div class="spacer"></div>
          <div v-if="!loading" >
            <v-btn round dark small color="green darken-3" @click="expandAll">
              <v-icon v-html="'fas fa-expand-arrows-alt'" small class="mr-1"/>expand all
            </v-btn>
            <v-btn round dark small color="orange darken-3" @click="collapseAll">
              <v-icon v-html="'fas fa-compress-arrows-alt'" small class="mr-1"/>collapse all
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text v-if="loading" class="elevation-1 white text-xs-center pa-3" style="transform: translateY(0px);">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-card-text>
        <v-card-text v-else-if="dataReady"> 
          <v-container>
            <v-expansion-panel v-model="panel" popout expand>
              <v-expansion-panel-content
                v-for="(item,virtual_balance_id) in virtualBalances"
                :key="virtual_balance_id"
              >
                <div slot="header">
                  <h4>{{item.virtual_balance_id}}</h4>
                </div>
                <v-card>
                  <v-card-text class="grey lighten-4">
                    <v-layout row wrap>
                      <template v-if="!item.error">
                        <v-flex v-if="!item.balances.length" d-flex xs12 class="text-xs-center">
                          <span class="grey--text">
                            <i>Empty</i>
                          </span>
                        </v-flex>
                        <v-flex
                          v-else
                          v-for="balance in item.balances"
                          :key="balance.currency"
                          d-flex
                          xs12
                          sm6
                          md4
                        >
                          <v-card class="elevation-4 ma-2 mb-3">
                            <v-card-title>
                              <h3 class="primary--text">{{ balance.currency }}</h3>
                            </v-card-title>
                            <v-card-text class="pt-0">
                              <div>
                                <v-layout row>
                                  <v-flex xs8>
                                    <v-text-field label="Available" type="number" v-model.number="balance.available"></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </div>
                              <div>
                                <v-layout row>
                                  <v-flex xs8>
                                    <v-text-field label="Balance" type="number" v-model.number="balance.balance"></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </template>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <div class="spacer"></div>
                    <v-btn color="primary" @click="saveConfig(item)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-container>
        </v-card-text>
        
      </v-card>
    </v-container>
  </v-flex>
</template>

<script>
import MongoService from '../../services/mongo.service';
import MongoConnector from '../../services/mongo-connector.service';
import MessageDialog from '../../libs/message-dialog/';
import Alert from '../../libs/alert'
export default {
  data() {
    const service = new MongoConnector(null, 'virtual-balances', {});
    return {
      loading: true,
      service,
      dataReady: false,
      panel: [],
      virtualBalances: []
    };
  },
  async beforeMount() {
    try {
      this.loading = true
      this.dataReady = false
      this.virtualBalances = await this.service.find({
        sort: {virtual_balance_id: 1},
        limit: 999999 // set for no limit
      });
      this.dataReady = true
      this.loading = false
    } catch (e) {}
  },
  methods: {
    async refresh () {
      this.dataReady = true
      this.virtualBalances = await this.service.find({
        sort: {virtual_balance_id: 1},
        limit: 999999 // set for no limit
      });
      this.dataReady = true
    },
    async saveConfig(item) {
      try {
        await this.service.updateDocuments(item)
        await Alert.success({ message: item.virtual_balance_id + ' updated' })
      } catch (e) {
        MessageDialog.showErrorMessage({ text: e.toString() })
        console.error(e)
      }
    },
    // Create an array the length of our items
    // with all values as true
    expandAll() {
      this.panel = [...this.virtualBalances].map(_ => true);
    },
    // Reset the panel
    collapseAll() {
      this.panel = [];
    }
  }
};
</script>